$(document).ready(() => {

    $('.preloader').fadeIn(200, () => {
        setTimeout(() => {
            $('.preloader').fadeOut(400);
            $('.preload-content').show(); 
        }, 2000);
    });

});



// WEBPACK FOOTER //
// ./src/js/preloader.js